import React from 'react';
import * as S from './styles';

export const Select = ({ children, spacing, spaceBetween, full, ...rest }) => (
    <S.ContainerOption hasSpacing={!!spacing} spaceBetween={!!spaceBetween} full={!!full} {...rest}>
        {children}
    </S.ContainerOption>
);
